import { Dropdown, DropdownProps, GetProp, Menu } from 'antd';
import Styles from './assets/Styles.scss';
import { IButtonOverflowItem } from './entities/IButtonOverflowItem';

type MenuItems = GetProp<typeof Menu, 'items'>;
const dropdownTrigger = ['click' as const];

const OverflowButtons: React.FC<{
	items: IButtonOverflowItem[];
	dropdownProps: DropdownProps;
}> = props => {
	if (!props.items.length) return null;

	const overflowMenu = (_items: IButtonOverflowItem[]): MenuItems => {
		return _items.map(item => {
			if (item.onRender) {
				return {
					key: item.key,
					label: item.onRender(item)
				};
			}

			if (item.type === 'divider') {
				return {
					key: item.key,
					type: item.type
				};
			}

			const { children, onClick, icon, disabled, title } = item.buttonProps || {};

			return {
				key: item.key,
				label: item.onRender?.(item) || children,
				onClick: e => {
					onClick?.(e.domEvent as React.MouseEvent<HTMLElement, MouseEvent>, item);
				},
				icon,
				disabled,
				type: item.type,
				title,
				children: item.items?.length ? overflowMenu(item.items) : undefined,
				popupClassName: Styles.dropdown,
				...item.dropdownMenuItemProps
			};
		});
	};

	return (
		<Dropdown
			trigger={dropdownTrigger}
			placement="bottomRight"
			{...props.dropdownProps}
			menu={{
				items: props.items ? overflowMenu(props.items) : undefined,
				className: Styles.dropdown,
				...props.dropdownProps?.menu
			}}
		>
			{props.children}
		</Dropdown>
	);
};

export { OverflowButtons };
